import axios from "axios";
import { urls } from "../utils/urls";
import { getProgramPolicyFallbackResponse } from "./programPolicyFallback";

export const fetchIndividualPrograms = async () => {
  try {
    const response = await axios.get(urls.fetchIndividualProgramsDataApi);
    if (response?.status === 200) {
      return response;
    }
  } catch (error) {
    console.warn(
      "Legacy program API unavailable, using policy fallback.",
      error?.message
    );
  }

  return getProgramPolicyFallbackResponse();
};
